export const apiEndpoints = {
    login: `/api-sp/resources/v3/loginUser?sourceAppType=CONSTELLATION_SELLER_APP`,
    logout: `/api-sp/resources/v3/logoutUser`,
    shopSelection: `/api-sp/resources/v3/staff/shopSelection`,
    posSession: `/api-sp/resources/v3/loginUser?sourceAppType=CONSTELLATION_SELLER_APP`,
    sellerDetails: 'api-db/resources/v2/dashboard/user/getUser',
    storeDetails: `/stores/`,
  };
  
  export const redirectionUrls = {
    sellerAppGooglePlayStore:
      'https://play.google.com/store/apps/details?id=com.amazon.sft.rangoli.seller.app',
    faqPage: 'https://smartbiz-support.zendesk.com/hc/en-us/sections/15674324808593-Select-a-Section',
    howToGuide: 'https://smartbiz-support.zendesk.com/hc/en-us',
    frequentlyAsked: 'https://help.smartbiz.in/hc/en-us/sections/18491586242321-FAQs',
  };
  
  export const ENV_STAGES = {
    localhost: 'local',
    ALPHA: 'alpha-smartbiz-seller.corp.amazon.com',
    BETA: 'beta-smartbiz-seller.corp.amazon.com',
    GAMMA: 'gamma-smartbiz-seller.corp.amazon.com',
    PROD: 'smartbiz.amazon.in',
  };
  